




























































































































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import RadioButton from '@/common/components/RadioButton.vue'
import Tooltip from '@/common/components/Tooltip.vue'
import SectionTitle from '@/product/components/SectionTitle.vue'

enum ORDER_METHODS {
  REGULAR,
  SAMPLE,
  PLAIN_PRODUCT
}

export default Vue.extend({
  components: {
    RadioButton,
    Tooltip,
    SectionTitle
  },
  data(): {
    orderMethods: typeof ORDER_METHODS,
    activeMethod: number,
    hoveredMethod: number,
    methodsDes: { [key: number] : string },
    bodyTheme: string,
    tooltipWidth: number
  } {
    return {
      orderMethods: ORDER_METHODS,
      activeMethod:  ORDER_METHODS.REGULAR,
      hoveredMethod:  ORDER_METHODS.REGULAR,
      methodsDes: {
        [ORDER_METHODS.REGULAR]: '商品にデザインを印刷する注文です。<br>同じ商品 {product_option}で増刷を頂く場合は版代が掛かりません。',
        [ORDER_METHODS.SAMPLE]: '商品にデザインを印刷する注文です。最小の数量で印刷できます。<br>同じ商品 {product_option}で本発注を頂く場合は版代が掛かりません。',
        [ORDER_METHODS.PLAIN_PRODUCT]: '印刷を行わない、商品のみの注文です。複数回ご注文された場合、注文をお断りさせていただくことがございますので予めご了承ください。'
      },
      bodyTheme:'sw-Tooltip_Light',
      tooltipWidth: 240
    }
  },
  computed: {
    ...mapGetters([
      'estimate',
      'product',
      'isAllowTrial'
    ]),
    selectedFirstOption(): string {
      return this.estimate?.first_selected_option?.sku_selection_name || ''
    },
    selectedSecondOption(): string {
      return this.estimate?.second_selected_option?.sku_selection_name || ''
    },
    allowFirstOption(): boolean {
      return !this.product.disable_first_option_when_reorder
    },
    allowSecondOption(): boolean {
      return !this.product.disable_second_option_when_reorder
    },
    allowWrappingOption(): boolean {
      return this.product.wrapping_options.length > 1
    },
    productOptionMessage(): string {
      const opts: string[] = []
      this.allowFirstOption && this.selectedFirstOption && opts.push(this.selectedFirstOption)
      this.allowSecondOption && this.selectedSecondOption && opts.push(this.selectedSecondOption)
      this.allowWrappingOption && this.$store.getters.wrappingSelectedOption && opts.push('封入オプション')
      return opts.length > 0 ? `(${opts.join(', ')}は変更可) ` : ''
    },
    description(): string {
      return this.methodsDes[this.hoveredMethod].replace('{product_option}', this.productOptionMessage)
    },
    enableSample(): boolean {
      return this.isAllowTrial
    },
    enablePlainProduct(): boolean {
      return this.product.plain_good === true
    },
    simplePlainGoodLabel(): string {
      return this.product.plain_good_max_quantity > 1 ? '印刷なし' : '無地サンプル'
    }
  },
  created() {
    if (this.estimate.trial) {
      this.activeMethod = this.orderMethods.SAMPLE
    } else if (this.estimate.plain_good) {
      this.activeMethod = this.orderMethods.PLAIN_PRODUCT
    }
  },
  methods: {
    onHoverOrderMethod(orderMethod: number) {
      if (this.hoveredMethod === orderMethod) return
      this.hoveredMethod = orderMethod
    },
    onChangeOrderMethod(orderMethod: number,orderDisabled?: boolean) {
      if (this.activeMethod === orderMethod || orderDisabled) return
      this.activeMethod = orderMethod
      this.updateInfoByOrderMethod()
      this.$emit('refreshProductInfo', {})
    },
    updateInfoByOrderMethod() {
      switch (this.activeMethod) {
        case this.orderMethods.REGULAR:
          return this.onSelectRegularOrderHandler()
        case this.orderMethods.SAMPLE:
          return this.onSelectSampleOrderHandler()
        case this.orderMethods.PLAIN_PRODUCT:
          return this.onSelectPlainGoodOrderHandler()
      }
    },
    onSelectRegularOrderHandler() {
      this.$store.commit('setSelectedTrial', false)
      this.$store.commit('setIsOrderPlainProduct', false)
    },
    onSelectSampleOrderHandler() {
      this.$store.commit('setValidQuantity', true)
      this.$store.commit('setSelectedTrial', true)
      this.$store.commit('setIsOrderPlainProduct', false)
    },
    onSelectPlainGoodOrderHandler() {
      this.$store.commit('setSelectedTrial', false)
      this.$store.commit('setIsOrderPlainProduct', true)
    }
  }
})
